const orderSort = (data) => {
  if (!data) {
    return [];
  }
  return [...data].sort((a, b) => a.order - b.order);
};

export default orderSort;
